package br.com.heyagenda.ui.components

import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import br.com.heyagenda.ui.theme.AuraBorderSubtle
import br.com.heyagenda.ui.theme.AuraCardSurface

@Composable
fun AuraCard(
    modifier: Modifier = Modifier,
    backgroundColor: Color = AuraCardSurface,
    borderColor: Color = AuraBorderSubtle,
    cornerRadius: Dp = 20.dp,
    onClick: (() -> Unit)? = null,
    content: @Composable BoxScope.() -> Unit
) {
    val shape = RoundedCornerShape(cornerRadius)
    Surface(
        modifier = modifier
            .clip(shape)
            .border(width = 1.dp, color = borderColor, shape = shape)
            .then(
                if (onClick != null) Modifier.clickable { onClick() } else Modifier
            ),
        color = backgroundColor,
        shape = shape
    ) {
        Box(content = content)
    }
}
